import { ArrowTopRightOnSquareIcon } from "@heroicons/react/16/solid";
import { ArrowUturnLeftIcon, ClipboardDocumentIcon } from "@heroicons/react/20/solid";
import React from "react";
import { Text } from "../tailwind/text";
import "./template-preview.css";


export const ButtonsPreview = ({ buttonsMap }) => {

  const ButtonPreview = ({ type, title }) => {
    const Icon = () => {
      switch (type) {
        case "quickReply":
          return <ArrowUturnLeftIcon className="mr-1 h-[16px]" />;
        case "url":
          return <ArrowTopRightOnSquareIcon className="mr-1 h-[16px]" />;
        case "copyCode":
          return <ClipboardDocumentIcon className="mr-1 h-[16px]" />;
        default:
          return null;
      }
    };

    return (
      <div className="button-preview">
        <div className="flex items-center">
          <Icon />
          <Text className="text-center w-full text-[#31795c]">{title}</Text>
        </div>
      </div>
    );
  };

  return (
    <div className="buttons-preview w-full">
      {buttonsMap.get('copyCodeButton')?.text && <ButtonPreview type="copyCode" title='Copy offer code' />}
      {buttonsMap.has('urlButton') && !buttonsMap.has('isUrlButtonAtBottom') && <ButtonPreview type="url" title={buttonsMap.get('urlButton')} />}
      {buttonsMap.has('urlButton2') && !buttonsMap.has('isUrlButtonAtBottom') && <ButtonPreview type="url" title={buttonsMap.get('urlButton2')} />}
      {buttonsMap.has('quickReply1') && <ButtonPreview type="quickReply" title={buttonsMap.get('quickReply1')} />}
      {buttonsMap.has('quickReply2') && <ButtonPreview type="quickReply" title={buttonsMap.get('quickReply2')} />}
      {buttonsMap.has('quickReply3') && <ButtonPreview type="quickReply" title={buttonsMap.get('quickReply3')} />}
      {buttonsMap.has('urlButton') && buttonsMap.has('isUrlButtonAtBottom') && <ButtonPreview type="url" title={buttonsMap.get('urlButton')} />}
      {buttonsMap.has('urlButton2') && buttonsMap.has('isUrlButtonAtBottom') && <ButtonPreview type="url" title={buttonsMap.get('urlButton2')} />}
    </div>
  );
};
